import { render, staticRenderFns } from "./ModalImportCustomer.vue?vue&type=template&id=6c3995d5&scoped=true&"
import script from "./ModalImportCustomer.vue?vue&type=script&lang=js&"
export * from "./ModalImportCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3995d5",
  null
  
)

export default component.exports